export const dadDrinks = [
  {
    name: 'Manhattan',
    image: 'https://i.ibb.co/k9vnnqX/manhattan-edited.jpg',
    imageTitle:
      'Original image by Graeme Maclean from Glasgow, UK - manhattan, CC BY 2.0, https://commons.wikimedia.org/w/index.php?curid=45273416',
    description: `A classic drink for dads.`,
  },
  {
    name: 'Old Fashioned',
    image: 'https://i.ibb.co/3WMQgXM/Old-fashioned.jpg',
    imageTitle: '',
    description: `🥃 A dad's favorite drink by far.`,
  },
  {
    name: 'Bushwacker',
    image: 'https://i.ibb.co/NxxP5z9/bushwacker.png',
    imageTitle: '',
    description: 'Just a dad relaxing on the beach. 🌴 ',
  },
  {
    name: 'Cuba Libre',
    image: 'https://i.ibb.co/DwTjVZf/cuba-libre.png',
    imageTitle: '',
    description: 'Rum and Coke with lime juice? "Yes" -- dads',
  },
  {
    name: 'Daquiri',
    image: 'https://i.ibb.co/qCY9rcP/Annotation-2020-04-18-175133.png',
    imageTitle: 'Tim Nusog',
    description: 'Dads who read Hemingway and like to play it cool.',
  },
  {
    name: 'Mount Gay & Tonic',
    image: 'https://i.ibb.co/d6bfCJZ/mgt.png',
    imageTitle: '',
    description: '⛵ Dads who own a sailboat all drink this dadtini classic.',
  },
  {
    name: 'Martini',
    image: 'https://i.ibb.co/PzHFNkZ/martini-edited.png',
    imageTitle:
      'original photo: John Phelan / CC BY-SA (https://creativecommons.org/licenses/by-sa/3.0)',
    description:
      'Shaken. Not stirred.🍸 Dads who have watched James Bond before probably.',
  },
  {
    name: 'Sazerac',
    image: 'https://i.ibb.co/2shhCZ5/sazerac.jpg',
    imageTitle: '',
    description:
      'Both dads and grand dads alike will tip their hats to this wonderful dadtini.',
  },
  {
    name: `Dark 'n' Stormy`,
    image:
      'https://i.ibb.co/SvDcmGD/darkandstormy-cefb02d2e27f2c4bd124e641c86b545f-today-inline-large.jpg',
    imageTitle: '',
    description: `Try seeing if this one doesn't come up during a convo of dads talking about boats.`,
  },
];
